import { render, staticRenderFns } from "./Amenity.vue?vue&type=template&id=cefb8748&"
import script from "./Amenity.vue?vue&type=script&lang=js&"
export * from "./Amenity.vue?vue&type=script&lang=js&"
import style0 from "./Amenity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports